var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 32,
    viewBox: "0 0 127 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 14.8986C69.1667 15.2835 69.1667 16.2458 68.5 16.6307L60.25 21.3938C59.5833 21.7787 58.75 21.2976 58.75 20.5278L58.75 11.0015C58.75 10.2317 59.5833 9.75057 60.25 10.1355L68.5 14.8986Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1C17 0.447715 17.4477 0 18 0H31C31.5523 0 32 0.447715 32 1V14C32 14.5523 31.5523 15 31 15H18C17.4477 15 17 14.5523 17 14V1Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 17.4477 0.447715 17 1 17H14C14.5523 17 15 17.4477 15 18V31C15 31.5523 14.5523 32 14 32H1C0.447715 32 0 31.5523 0 31V18Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H14C14.5523 0 15 0.447715 15 1V14C15 14.5523 14.5523 15 14 15H1C0.447715 15 0 14.5523 0 14V1Z",
    fill: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 1C112 0.447715 112.448 0 113 0H126C126.552 0 127 0.447715 127 1V14C127 14.5523 126.552 15 126 15H113C112.448 15 112 14.5523 112 14V1Z",
    fill: "#DDDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112 18C112 17.4477 112.448 17 113 17H126C126.552 17 127 17.4477 127 18V31C127 31.5523 126.552 32 126 32H113C112.448 32 112 31.5523 112 31V18Z",
    fill: "#67A258"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18C95 17.4477 95.4477 17 96 17H109C109.552 17 110 17.4477 110 18V31C110 31.5523 109.552 32 109 32H96C95.4477 32 95 31.5523 95 31V18Z",
    fill: "#DDDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95 1C95 0.447715 95.4477 0 96 0H109C109.552 0 110 0.447715 110 1V14C110 14.5523 109.552 15 109 15H96C95.4477 15 95 14.5523 95 14V1Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorn);
export default __webpack_public_path__ + "static/media/Born.9073fde4f508f455fa20b1c0657db11c.svg";
export { ForwardRef as ReactComponent };